import request from '@/utils/request'

export const getTrialBalance = params => request.get('/accounting/reports/trial-balance', { params })
